import { api } from "../../common/config/api";

export const ADMINS_URL = {
   createAdmin: `${api.withAPI}/v1/admin`,
   getAdmins: `${api.withAPI}/v1/admin`,
   removeAdmin: `${api.withAPI}/v1/admin`,
   getAdmin: `${api.withAPI}/v1/admin`,
   editAdmin: `${api.withAPI}/v1/admin`
}
